import { FormEventHandler, useState } from "react";
import NavbarTop from "../components/NavbarTop";
import NavbarIcons from "../components/NavbarIcons";
import NavbarMobile from "../components/NavbarMobile";
import NavbarUser from "../components/NavbarUser";
import Footer from "../components/Footer";
import { toast } from "react-toastify";
import { api } from "../utils/apiClient";
import { useSelector } from "react-redux";
import { RootState } from "../store/redux/store";
import Banner from "../components/Banner";

declare global {
  interface Window {
    grecaptcha: any;
  }
}

const Contact = () => {
  const user: any = useSelector((state: RootState) => state.user.currentUser);

  const [name, setName] = useState(user?.name ?? "");
  const [email, setEmail] = useState(user?.email ?? "");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [website, setWebsite] = useState("");

  const sendMessage: FormEventHandler = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const token = await window.grecaptcha.execute(
        "6LeI57UtAAAAAJysD5-ouuhmqXYhPONSpViq41bs",
        {
          action: "contact_form",
        },
      );

      await api({
        method: "POST",
        url: "/api/message",
        data: {
          name,
          email,
          subject,
          text: message,
          website,
          recaptchaToken: token,
        },
      });

      setLoading(false);
      toast.success("Message sent");
      setName("");
      setEmail("");
      setSubject("");
      setMessage("");
    } catch (error: any) {
      setLoading(false);
      toast.error("Unable to send message.");
    }
  };

  return (
    <div className="flq-navbar-icons-existence">
      <NavbarTop page="Contact" />
      <Banner page="Contact" />
      <div className="content-wrap">
        <div className="pt-7">
          <div className="container">
            <div
              className="row gy-4 justify-content-center"
              data-sr="card-feature"
              data-sr-interval={100}
              data-sr-duration={1000}
              data-sr-distance={10}
            >
              <div
                className="col-12 col-md-6 col-lg"
                data-sr-item="card-feature"
              >
                <a
                  href="#/"
                  className="card flq-card-feature flq-card-feature-filled text-center"
                >
                  <span className="card-body">
                    <span className="card-icon">
                      <svg
                        width={30}
                        height={30}
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.8125 6.25C20.0335 6.48821 21.1555 7.08532 22.0351 7.96492C22.9147 8.84452 23.5118 9.96658 23.75 11.1875M18.8125 1.25C21.3491 1.5318 23.7145 2.66772 25.5203 4.47126C27.3262 6.2748 28.4651 8.63876 28.75 11.175M27.5 21.15V24.9C27.5015 25.2481 27.4301 25.5927 27.2907 25.9117C27.1512 26.2307 26.9467 26.517 26.6901 26.7523C26.4336 26.9877 26.1308 27.1669 25.801 27.2784C25.4712 27.3899 25.1218 27.4313 24.775 27.4C20.9286 26.9821 17.2338 25.6677 13.9875 23.5625C10.9673 21.6433 8.40671 19.0827 6.48754 16.0625C4.37501 12.8015 3.06034 9.08874 2.65004 5.225C2.6188 4.87933 2.65988 4.53095 2.77066 4.20203C2.88145 3.87311 3.0595 3.57086 3.2935 3.31453C3.52749 3.05819 3.81229 2.85339 4.12978 2.71315C4.44726 2.57292 4.79046 2.50033 5.13754 2.5H8.88754C9.49417 2.49403 10.0823 2.70885 10.5422 3.10442C11.0022 3.49998 11.3026 4.04931 11.3875 4.65C11.5458 5.85008 11.8394 7.02841 12.2625 8.1625C12.4307 8.60991 12.4671 9.09614 12.3674 9.5636C12.2677 10.0311 12.0361 10.4601 11.7 10.8L10.1125 12.3875C11.892 15.5169 14.4831 18.1081 17.6125 19.8875L19.2 18.3C19.5399 17.9639 19.969 17.7323 20.4364 17.6326C20.9039 17.5329 21.3901 17.5693 21.8375 17.7375C22.9716 18.1607 24.15 18.4542 25.35 18.6125C25.9572 18.6982 26.5118 19.004 26.9082 19.4719C27.3046 19.9397 27.5152 20.537 27.5 21.15Z"
                          stroke="currentColor"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <svg
                        width={30}
                        height={30}
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M27.5003 24.9V21.15C27.5155 20.537 27.3049 19.9397 26.9084 19.4719C26.512 19.004 25.9575 18.6982 25.3503 18.6125C24.1502 18.4542 22.9719 18.1607 21.8378 17.7375C21.3904 17.5693 20.9041 17.5329 20.4367 17.6326C19.9692 17.7323 19.5401 17.9639 19.2003 18.3L17.6128 19.8875C14.4834 18.1081 11.8922 15.5169 10.1128 12.3875L11.7003 10.8C12.0364 10.4601 12.268 10.0311 12.3677 9.5636C12.4674 9.09614 12.431 8.6099 12.2628 8.1625C11.8396 7.02841 11.5461 5.85008 11.3878 4.65C11.3029 4.04931 11.0024 3.49998 10.5425 3.10441C10.0825 2.70885 9.49442 2.49403 8.88778 2.5H5.13778C4.79071 2.50033 4.4475 2.57292 4.13002 2.71315C3.81254 2.85339 3.52773 3.05819 3.29374 3.31453C3.05975 3.57086 2.88169 3.87311 2.77091 4.20203C2.66013 4.53095 2.61905 4.87933 2.65028 5.225C3.06059 9.08874 4.37526 12.8015 6.48778 16.0625C8.40695 19.0827 10.9676 21.6433 13.9878 23.5625C17.234 25.6677 20.9288 26.982 24.7753 27.4C25.122 27.4313 25.4714 27.3899 25.8012 27.2784C26.131 27.1669 26.4339 26.9877 26.6904 26.7523C26.9469 26.517 27.1515 26.2307 27.2909 25.9117C27.4304 25.5927 27.5017 25.2481 27.5003 24.9Z"
                          fill="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                    <span className="card-title h5">Call Us</span>
                    <span className="paragraph">
                      <a href="tel:+2348146249531">(+234) 814 624 9531</a>
                    </span>
                  </span>
                </a>
              </div>
              <div
                className="col-12 col-md-6 col-lg"
                data-sr-item="card-feature"
              >
                <a
                  href="#/"
                  className="card flq-card-feature flq-card-feature-filled text-center"
                >
                  <span className="card-body">
                    <span className="card-icon">
                      <svg
                        width={30}
                        height={30}
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M27.5 7.5C27.5 6.125 26.375 5 25 5H5C3.625 5 2.5 6.125 2.5 7.5M27.5 7.5V22.5C27.5 23.875 26.375 25 25 25H5C3.625 25 2.5 23.875 2.5 22.5V7.5M27.5 7.5L15 16.25L2.5 7.5"
                          stroke="currentColor"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <svg
                        width={30}
                        height={30}
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M3.88322 6.94244L15 14.7242L26.1168 6.94244C25.9101 6.53365 25.485 6.25 25 6.25H5C4.51505 6.25 4.08995 6.53365 3.88322 6.94244ZM1.25 7.5C1.25 5.43464 2.93464 3.75 5 3.75H25C27.0654 3.75 28.75 5.43464 28.75 7.5V22.5C28.75 24.5654 27.0654 26.25 25 26.25H5C2.93464 26.25 1.25 24.5654 1.25 22.5V7.5Z"
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                    <span className="card-title h5">Write Us</span>
                    <span className="paragraph">
                      <a href="mailto:contact@thinklikeapianist.com">
                        contact@thinklikeapianist.com
                      </a>
                    </span>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="py-7">
          <div className="container-small">
            <div
              className="text-center mb-5"
              data-sr="contact-text"
              data-sr-interval={100}
              data-sr-duration={1000}
              data-sr-distance={10}
            >
              <span className="flq-subtitle badge" data-sr-item="contact-text">
                Contact Form
              </span>
              <h2 className="display-6" data-sr-item="contact-text">
                Say Hello
              </h2>
            </div>
            <form onSubmit={sendMessage}>
              <input
                type="text"
                name="website"
                value={website}
                onChange={(e) => setWebsite(e.target.value)}
                style={{
                  position: "absolute",
                  left: "-9999px",
                  top: "-9999px",
                }}
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
              />

              <div
                className="row gy-4"
                data-sr="contact-form"
                data-sr-interval={100}
                data-sr-duration={1000}
                data-sr-distance={10}
              >
                <div className="col-12 col-sm" data-sr-item="contact-form">
                  <input
                    className="form-control flq-form-user form-control-lg"
                    name="name"
                    type="text"
                    placeholder="Your Name"
                    required
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                    }}
                  />
                </div>
                <div className="col-12 col-sm" data-sr-item="contact-form">
                  <input
                    className="form-control flq-form-mail form-control-lg"
                    name="email"
                    type="email"
                    placeholder="Your Email"
                    required
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                  />
                </div>
                <div className="col-12" data-sr-item="contact-form">
                  <input
                    className="form-control flq-form-message form-control-lg"
                    type="text"
                    placeholder="Subject"
                    value={subject}
                    onChange={(e) => {
                      setSubject(e.target.value);
                    }}
                  />
                </div>
                <div className="col-12" data-sr-item="contact-form">
                  <textarea
                    className="form-control flq-form-message form-control-lg"
                    rows={5}
                    placeholder="Your Message"
                    required
                    value={message}
                    onChange={(e) => {
                      setMessage(e.target.value);
                    }}
                  />
                </div>

                <div className="col-12" data-sr-item="contact-form">
                  {loading ? (
                    <button className="btn btn-lg btn-block" disabled>
                      Submit
                    </button>
                  ) : (
                    <button className="btn btn-lg btn-block">Submit</button>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>

        <Footer />
      </div>

      <NavbarIcons />
      <NavbarMobile page="Contact" />
      <NavbarUser page="Contact" />
    </div>
  );
};

export default Contact;
